export default __webpack_public_path__ + "static/media/ambassador.87ead65b.jpg";